import { Check, X } from "lucide-react";

export function isStrongPassword(v) {
  return (v || "").length >= 8 && /\d/.test(v || "");
}

export function PasswordStrength({ value }) {
  const v = value || "";
  if (!v) return null;
  const hasLen = v.length >= 8;
  const hasNum = /\d/.test(v);
  const extra = (v.length >= 12 ? 1 : 0) + (/[^A-Za-z0-9]/.test(v) ? 1 : 0);
  const score = (hasLen ? 1 : 0) + (hasNum ? 1 : 0) + extra;
  const pct = Math.min(100, Math.max(20, (score / 4) * 100));
  const color = score >= 3 ? "bg-emerald-500" : score >= 2 ? "bg-amber-500" : "bg-rose-500";
  const label = score >= 3 ? "Sterk" : score >= 2 ? "Redelijk" : "Zwak";
  const Rule = ({ ok, txt }) => (
    <span className={`inline-flex items-center gap-1 ${ok ? "text-emerald-600" : "text-slate-400"}`}>
      {ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}{txt}
    </span>
  );
  return (
    <div className="mt-2" data-testid="pw-strength">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
        <div className={`h-full rounded-full transition-all duration-300 ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[11px]">
        <span className={`font-semibold ${score >= 3 ? "text-emerald-600" : score >= 2 ? "text-amber-600" : "text-rose-600"}`}>{label}</span>
        <Rule ok={hasLen} txt="min. 8 tekens" />
        <Rule ok={hasNum} txt="min. 1 cijfer" />
      </div>
    </div>
  );
}
